module.exports = __webpack_public_path__ + "static/img/094.14ca765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/094.png
// module id = jrsq
// module chunks = 0